<template>
  <LazySelect
    v-model="selectedId"
    :fetcher="fetchClients"
    :resolve-selected="resolveSelectedClient"
    option-label="fullName"
    option-value="id"
    :filter-fields="['fullName']"
    :placeholder="languageStore.t('general.selectClient')"
    :empty-message="languageStore.t('general.noDataFound')"
    :loading-message="languageStore.t('general.loading')"
    :disabled="disabled"
    :page-size="20"
    class="w-full text-sm"
    @change="emit('change')"
  />
</template>

<script lang="ts" setup>
import LazySelect, { type LazySelectFetchParams } from '@/components/subcomponents/LazySelect.vue'
import * as userClientService from '@/services/userClientService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { computed } from 'vue'

const props = defineProps<{
  modelValue?: string | null
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | null): void
  (e: 'change'): void
}>()

const languageStore = useLanguageStore()

const selectedId = computed({
  get: () => props.modelValue ?? null,
  set: (value) => emit('update:modelValue', (value as string) ?? null),
})

async function fetchClients({ page, pageSize, search, signal }: LazySelectFetchParams) {
  const res = await userClientService.getMyClients(page, pageSize, search || undefined, signal)
  return res.data
}

async function resolveSelectedClient() {
  const res = await userClientService.getCurrentClient()
  return res.data
}
</script>
